var map = {
	"./photo.png": 16590,
	"./photo1.png": 86197,
	"./photo2.png": 18846,
	"./photo3.png": 37159,
	"./photo4.png": 61992,
	"./photo5.png": 59857,
	"./photo6.png": 46042,
	"./photo7.png": 47267,
	"./photo8.png": 89604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25341;